import { useMoveToWebview } from './moveToWebview';
import { moveToToday } from './moveToToday';
import { useMoveToScreens } from './moveToScreens';
import { useMoveToHome } from './moveToHome';
import { useMoveToLikeFolders } from './moveToLikeFolders';
import { useMoveToLikeMarketList } from './moveToLikeMarketList';
import { useMoveToEditGoodsLike } from './moveToEditGoodsLike';
import { moveToRoot } from './moveToRoot';
import { useMoveToCategoryTab } from './moveToCategoryTab';
import { useMoveToCategory } from './moveToCategory';
import { useMoveToSetting } from './moveToSetting/moveToSetting';
import { useMoveToNotification } from './moveToNotification/moveToNotification';
import { useMoveToEmailLogin } from './moveToEmailLogin';
import { useMoveToLogin } from './moveToLogin';
import { useMoveToAlreadyRegistered } from './moveToAlreadyRegistered';
import { useMoveToRecoveryId } from './moveToRecoveryId';
import { useMoveToRecoveryPassword } from './moveToRecoveryPassword';

export const useCommonNavigator = () => {
  const moveToWebview = useMoveToWebview();
  const moveToScreens = useMoveToScreens();
  const moveToHome = useMoveToHome();
  const moveToLikeFolders = useMoveToLikeFolders();
  const moveToLikeMarketList = useMoveToLikeMarketList();
  const moveToEditGoodsLike = useMoveToEditGoodsLike();
  const moveToCategoryTab = useMoveToCategoryTab();
  const moveToCategory = useMoveToCategory();
  const moveToSetting = useMoveToSetting();
  const moveToNotification = useMoveToNotification();
  const moveToEmailLogin = useMoveToEmailLogin();
  const moveToLogin = useMoveToLogin();
  const moveToAlreadyRegistered = useMoveToAlreadyRegistered();
  const moveToRecoveryId = useMoveToRecoveryId();
  const moveToRecoveryPassword = useMoveToRecoveryPassword();

  return {
    moveToRoot,
    moveToWebview,
    moveToToday,
    moveToScreens,
    moveToHome,
    moveToLikeFolders,
    moveToLikeMarketList,
    moveToEditGoodsLike,
    moveToCategoryTab,
    moveToCategory,
    moveToSetting,
    moveToNotification,
    moveToEmailLogin,
    moveToLogin,
    moveToAlreadyRegistered,
    moveToRecoveryId,
    moveToRecoveryPassword,
  };
};
